import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/user-management/create/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.USER_MANAGEMENT, permission: Permission.CREATE });
    context.validatePermissions({ isAllowed, preload });
  },
});
